"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bundleCodes = exports.couponCodes = exports.kingPillowSkus = exports.queenPillowSkus = exports.pillowBundleSkus = exports.pillows = void 0;
exports.pillows = [
    'the-saatva-pillow',
    'memory-foam-pillow',
    'down-alternative-pillow',
    'cloud-memory-foam-pillow',
    'organic-quilted-pillow'
];
exports.pillowBundleSkus = {
    'P27D31CF18-SQ': 'P27D31CF18-2PKQ', // The Saatva Pillow in Queen, 2-Pack Bundle high loft
    'P27D31CF18-K': 'P27D31CF18-2PKK', // The Saatva Pillow in King, 2-Pack Bundle high loft
    'SAOLXPLWLL-Q': 'SAOLXPLL2PK-Q', // The Saatva Pillow in Queen, 2-Pack Bundle standard loft
    'SAOLXPLWLL-K': 'SAOLXPLL2PK-K', // The Saatva Pillow in King, 2-Pack Bundle standard loft
    'SAAGRPHPLW-Q': 'SAAGRPHPLW2PK-Q', // Memory Foam Pillow in Queen, 2-Pack Bundle
    'SAAGRPHPLW-K': 'SAAGRPHPLW2PK-K', // Memory Foam Pillow in King, 2-Pack Bundle
    'SAA5050PLW-Q': 'SAA5050PLW2PK-Q', // Down Alternative Pillow in Queen, 2-Pack Bundle
    'SAA5050PLW-K': 'SAA5050PLW2PK-K', // Down Alternative Pillow in King, 2-Pack Bundle
    'SACLDMFNPLW-Q': 'SACLDMFNP2PK-Q', // Cloud Memory Foam Pillow in Queen, 2-Pack Bundle
    'SACLDMFNPLW-K': 'SACLDMFNP2PK-K', // Cloud Memory Foam Pillow in King, 2-Pack Bundle
    'SAORGQPLW-Q': 'SAORGQPL2PK-Q', // Organic Quilted Pillow in Queen, 2-Pack Bundle
    'SAORGQPLW-K': 'SAORGQPL2PK-K', // Organic Quilted Pillow in King, 2-Pack Bundle
    'SAAMFPLW-Q': 'SAAMFPLW-2PKQ', // Cloud Memory Foam Pillow in King, Standard loft, 2-Pack Bundle
    'SAAMFPLW-K': 'SAAMFPLW-2PKK', // Cloud Memory Foam Pillow in Queen, Standard loft, 2-Pack Bundle
    'SAAGMFPLW-Q': 'SAAGMFPLW-2PKQ', // Memory Foam Pillow in Queen, Standard Loft, 2-Pack Bundle
    'SAAGMFPLW-K': 'SAAGMFPLW-2PKK', // Memory Foam Pillow in King, Standard Loft, 2-Pack Bundle
    'SAAOQPLW-Q': 'SAAOQPLW-2PKQ', // Organic Quilted Pillow in Queen, Standard Loft, 2-Pack Bundle
    'SAAOQPLW-K': 'SAAOQPLW-2PKK', // Organic Quilted Pillow in King, Standard Loft, 2-Pack Bundle
    'SAA5050STDPLW-Q': 'SAA5050STDPLW2Q', // Down Alternative Pillow in King Standard loft, 2-Pack Bundle
    'SAA5050STDPLW-K': 'SAA5050STDPLW2K' // Down Alternative Pillow in Queen Standard loft, 2-Pack Bundle
};
exports.queenPillowSkus = [
    'P27D31CF18-SQ',
    'SAOLXPLWLL-Q',
    'SAAGRPHPLW-Q',
    'SAA5050PLW-Q',
    'SACLDMFNPLW-Q',
    'SAORGQPLW-Q'
];
exports.kingPillowSkus = [
    'P27D31CF18-K',
    'SAOLXPLWLL-K',
    'SAAGRPHPLW-K',
    'SAA5050PLW-K',
    'SACLDMFNPLW-K',
    'SAORGQPLW-K'
];
exports.couponCodes = {
    'checkoutBedding': '10OFFBEDDING'
};
exports.bundleCodes = [
    'classic-starter-bundle',
    'sateen-sheets-latex-pillow-pad',
    'sateen-sheets-latex-pillow',
    'sateen-sheets-memory-foam-pillow',
];
//# sourceMappingURL=globals.js.map